import { setCookie, getCookie } from './cookies';

export function themeToggle() {
  const themeToggleButton: HTMLElement | null = document.querySelector('#themeToggleButton');
  const body: HTMLElement | null = document.querySelector('body');

  if (themeToggleButton != null && body != null) {
    // Set the last saved theme.
    let theme = getCookie('theme');
    if (theme === 'dark') {
      body.classList.add('dark-theme');
      themeToggleButton.classList.add('active');
    }

    // Set the theme color on themeToggleButton click event.
    themeToggleButton.addEventListener('click', function toggleTheme(mouseEvent: MouseEvent) {
      mouseEvent.preventDefault();

      // Toggle the dark theme classes.
      body.classList.toggle('dark-theme');
      this.classList.toggle('active');

      // Save the current theme with cookies.
      if (body.classList.contains('dark-theme')) {
        setCookie('theme', 'dark', 7);
      }
      else {
        setCookie('theme', 'light', 7);
      }
    });
  }
}
